export enum Pages {
  CurrentTrips = 'MisViajesActualesPage',
  TripDetails = 'VerDetallesPage',
  MapTrip = 'MapaViajePage',
  PreviousTrips = 'MisViajesPasadosPage',
  Stops = 'VerParadasPage',
  Consignment = 'ConsignmentPage',
  Help = 'AyudaPage',
  Login = 'LoginPage',
  Evidence = 'EvidenciaPage',
  Rating = 'CalificacionesPage',
  Tutorial = 'TutorialPage',
  Rejection = 'RechazoPage',
  Pod = 'PodPage',
  NotificationsCenter = 'NotificationsCenterPage',
  UpdatePassword = 'UpdatePasswordPage',
  Telemetrics = 'AddTelemetricsPage',
}
